export enum WEIGHING_UNITS {
  KG = 'KG',
  G = 'G',
}
